//painel-admin/src/pages/SorteioLeadsAdmin.jsx

import React, { useEffect, useState } from "react";
import axios from "../axiosConfig";
import { Link, useParams } from "react-router-dom";
import {
  ArrowLeft,
  ClipboardCopy,
  Download,
  Loader2,
  RefreshCcw,
  UsersRound
} from "lucide-react";
import "./SorteioLeadsAdmin.css";

function SorteioLeadsAdmin() {
  const { id } = useParams();

  const [sorteio, setSorteio] = useState(null);
  const [leads, setLeads] = useState([]);
  const [mensagem, setMensagem] = useState("");
  const [loading, setLoading] = useState(false);

  const buscarLeads = async () => {
    setMensagem("");
    setLoading(true);

    try {
      const { data } = await axios.get(`/admin/sorteios-leads/id/${id}`);

      setSorteio(data.sorteio);
      setLeads(Array.isArray(data.participantes) ? data.participantes : []);
      setMensagem(`${data.participantes?.length || 0} participante(s) encontrado(s).`);
    } catch (err) {
      console.error("Erro ao buscar leads:", err);
      setLeads([]);
      setMensagem(
        err.response?.data?.error ||
          "Não foi possível buscar os participantes."
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) buscarLeads();
    
  }, [id]);

  const copiarNomes = async () => {
    const nomes = leads.map((l) => l.nome).filter(Boolean).join("\n");

    if (!nomes) {
      setMensagem("Não há nomes para copiar.");
      return;
    }

    try {
      await navigator.clipboard.writeText(nomes);
      setMensagem("Nomes copiados. Agora é só colar no sorteador atual.");
    } catch {
      setMensagem("Não foi possível copiar automaticamente. Selecione e copie manualmente.");
    }
  };

  const exportarCSV = () => {
    if (!leads.length) {
      setMensagem("Não há participantes para exportar.");
      return;
    }

    const header = ["nome", "empresa", "email", "whatsapp", "criado_em"];

    const linhas = leads.map((lead) =>
      header
        .map((campo) => {
          const valor = String(lead[campo] || "").replace(/"/g, '""');
          return `"${valor}"`;
        })
        .join(",")
    );

    const csv = [header.join(","), ...linhas].join("\n");
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = `leads-sorteio-${sorteio?.slug || id}.csv`;
    document.body.appendChild(a);
    a.click();
    a.remove();

    URL.revokeObjectURL(url);
  };

  const formatarData = (valor) => {
    if (!valor) return "-";

    try {
      return new Date(valor).toLocaleString("pt-BR");
    } catch {
      return "-";
    }
  };

  return (
    <div className="sorteioLeadsAdmin-page">
      <div className="sorteioLeadsAdmin-header">
        <Link to="/admin/sorteios-leads" className="sorteioLeadsAdmin-back">
          <ArrowLeft size={16} />
          Voltar
        </Link>

        <span className="sorteioLeadsAdmin-kicker">Sorteios Tikpag</span>

        <h1>Leads do Sorteio</h1>

        <p>
          {sorteio?.titulo
            ? `Participantes cadastrados em: ${sorteio.titulo}`
            : "Consulte os participantes cadastrados pelo QR Code."}
        </p>

        {sorteio?.slug && (
          <code className="sorteioLeadsAdmin-publicLink">
            /sorteios/{sorteio.slug}
          </code>
        )}
      </div>

      <section className="sorteioLeadsAdmin-card">
        <div className="sorteioLeadsAdmin-toolbar">
          <div>
            <h2>Participantes</h2>
            <span>{leads.length} cadastro(s)</span>
          </div>

          <div className="sorteioLeadsAdmin-actions">
            <button type="button" onClick={buscarLeads} disabled={loading}>
              {loading ? (
                <Loader2 size={16} className="sorteioLeadsAdmin-spin" />
              ) : (
                <RefreshCcw size={16} />
              )}
              Atualizar
            </button>

            <button type="button" onClick={copiarNomes} disabled={!leads.length}>
              <ClipboardCopy size={16} />
              Copiar nomes
            </button>

            <button type="button" onClick={exportarCSV} disabled={!leads.length}>
              <Download size={16} />
              Exportar CSV
            </button>
          </div>
        </div>

        {mensagem && (
          <div className="sorteioLeadsAdmin-message">
            {mensagem}
          </div>
        )}

        {leads.length === 0 ? (
          <div className="sorteioLeadsAdmin-empty">
            <UsersRound size={34} />
            Nenhum participante carregado ainda.
          </div>
        ) : (
          <div className="sorteioLeadsAdmin-tableWrap">
            <table className="sorteioLeadsAdmin-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Nome</th>
                  <th>Empresa</th>
                  <th>E-mail</th>
                  <th>WhatsApp</th>
                  <th>Cadastro</th>
                  <th>Prêmio</th>
                </tr>
              </thead>

              <tbody>
                {leads.map((lead, index) => (
                  <tr key={lead.id || index}>
                    <td>{index + 1}</td>
                    <td>
                      <strong>{lead.nome}</strong>
                    </td>
                    <td>{lead.empresa || "-"}</td>
                    <td>{lead.email}</td>
                    <td>{lead.whatsapp}</td>
                    <td>{formatarData(lead.criado_em)}</td>
                    <td>
                    {lead.premio_ganho ? (
                      <strong>{lead.premio_ganho}</strong>
                    ) : lead.desclassificado ? (
                      <span>Desclassificado</span>
                    ) : (
                      "-"
                    )}
                  </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </section>
    </div>
  );
}

export default SorteioLeadsAdmin;